export const SENTRY_RELEASE: string | undefined = 'ddd71b64db2bc11d8495d451ab5eca3e816423b4';
